export class NotificationStateAction {
  constructor(
    public isDeleted: boolean = false,
    public isRead: boolean = false,
    public isAllDeleted: boolean = false,
    public isAllRead: boolean = false
  ) {}
}
